export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS40MTQiIGhlaWdodD0iMjUuNDE0IiB2aWV3Qm94PSIwIDAgMjUuNDE0IDI1LjQxNCI+CiAgPGcgaWQ9IkNsb3NlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjcwNyAwLjcwNykiPgogICAgPGxpbmUgaWQ9IkxpbmVfMyIgZGF0YS1uYW1lPSJMaW5lIDMiIHkxPSIyNCIgeDI9IjI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMzYzNjM2MiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNCIgZGF0YS1uYW1lPSJMaW5lIDQiIHkxPSIyNCIgeDI9IjI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNCkgcm90YXRlKDkwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjM2MzYzNjIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./images/close_X.svg
// module id = 80
// module chunks = 0